import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import Env from '@ridango/core/env';
import { ApplicationFacade, SessionService } from '@ridango/components';
import { ThemeFeature } from '@ridango/core/lib/enums/features.enum';
import { HelperService } from '../../../services/helper.service';
import { AllowedPathService } from '@ridango/core';
import { Subject } from 'rxjs';
import { filter, map, startWith, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
@Component({
    selector: 'gl-footer-template-five-cols',
    templateUrl: './footer-template-five-cols.component.html',
    styleUrls: ['./footer-template-five-cols.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FooterTemplateFiveColsComponent implements OnInit, OnDestroy {
    logoFile: string;
    logoFileContrast: string;
    themeFeature = ThemeFeature;
    assetsPath$ = this.applicationFacade.assetsPath$;
    switchCorpLink: string;
    isWebPurchaseAllowed = this.pathService.isWebPurchaseAllowed();
    private destroy$ = new Subject<void>();
    showExtraFooter$ = this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd),
        map((event: NavigationEnd) => this.shouldShowExtraFooter(event.url)),
        startWith(this.shouldShowExtraFooter(this.router.url)),
        takeUntil(this.destroy$)
    );

    constructor(
        private applicationFacade: ApplicationFacade,
        public helperService: HelperService,
        @Inject('ENV') public env: Env,
        public ridangoAuth: SessionService,
        private pathService: AllowedPathService,
        private router: Router
    ) {}

    ngOnInit() {
        this.logoFile = this.env.FOOTER?.LOGO_FILE ?? 'logo-footer.svg';
        this.logoFileContrast = this.env.FOOTER?.LOGO_FILE_CONTRAST ?? 'logo-footer-contrast.svg';
        this.switchCorpLink = this.getSwitchLink();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    getSwitchLink(): string {
        if (this.env.IS_CORPORATE) {
            return this.env.BASE_URL.replace('-corp', '');
        } else {
            return this.env.BASE_URL.replace(this.env.APP_NAME, this.env.APP_NAME + '-corp');
        }
    }

    private shouldShowExtraFooter(url: string): boolean {
        return /^\/(?:[a-z]{2}\/)?(?:explore|journey-planner)/.test(url);
    }
}
